import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

const ListingSkeleton = () => {
  return (
    <>
      <Skeleton variant="text" width="60%" height={40} />
      <Box sx={{ display: "flex", justifyContent: "space-between", my: 3 }}>
        <Skeleton variant="text" width="30%" height={40} />
        <Skeleton variant="text" width="20%" height={40} />
      </Box>
      <Grid container spacing={3}>
        {Array.from(new Array(6)).map((_, index) => (
          <Grid size={{ xs: 6, md: 3 }} key={index}>
            <Skeleton variant="rounded" width="100%" height={250} />
            <Skeleton variant="text" width="80%" height={30} sx={{ mt: 1 }} />
            <Skeleton variant="text" width="60%" height={30} sx={{ mt: 1 }} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ListingSkeleton;
